import { useEffect } from "react";

/**
 * MotionPolish — powers mouse-tracked radial highlights on all
 * .card-raised elements. Passive listener with rAF throttling.
 * Auto-disables on touch devices and prefers-reduced-motion.
 */
export default function MotionPolish() {
  useEffect(() => {
    const isCoarse = window.matchMedia("(pointer: coarse)").matches;
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (isCoarse || reduced) return;

    let raf = 0;
    let pending = null;

    const flush = () => {
      raf = 0;
      if (!pending) return;
      const { target, x, y } = pending;
      target.style.setProperty("--mx", `${x}px`);
      target.style.setProperty("--my", `${y}px`);
      pending = null;
    };

    const onMove = (e) => {
      const card = e.target.closest ? e.target.closest(".card-raised") : null;
      if (!card) return;
      const rect = card.getBoundingClientRect();
      pending = {
        target: card,
        x: e.clientX - rect.left,
        y: e.clientY - rect.top,
      };
      if (!raf) raf = requestAnimationFrame(flush);
    };

    document.addEventListener("mousemove", onMove, { passive: true });
    return () => {
      document.removeEventListener("mousemove", onMove);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return null;
}
